import { render, staticRenderFns } from "./workcenter-audit.vue?vue&type=template&id=3ab8be00&"
import script from "./js/workcenter-audit.js?vue&type=script&lang=js&"
export * from "./js/workcenter-audit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports